import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";
import EnquiryModal from "@/components/site/EnquiryModal";
import SmoothScroll from "@/lib/SmoothScroll";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

export default function SiteLayout() {
  return (
    <SmoothScroll>
      <div className="min-h-screen bg-[#fdfbf7] text-[#2d1616] font-sans antialiased">
        <ScrollToTop />
        <Header />
        <main>
          <Outlet />
        </main>
        <Footer />
        <FloatingWhatsApp />
        <EnquiryModal />
      </div>
    </SmoothScroll>
  );
}
